import { ImProfile } from "react-icons/im";
export const supplierAccountingData = [
  {
    id: "1",
    name: "سفارشات تایید نشده",
    path: "/dashboard/suppliers/accounting/unconfirmedOrders",
    icon: <ImProfile size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "سفارشات در انتظار تحویل پیک",
    path: "/dashboard/suppliers/accounting/awaitingDelivery",
    icon: <ImProfile size={25} />,
    color: "#f1416c",
    type: "menu",
  },
];
